import React from 'react';
import PropTypes from 'prop-types';

import { Select, MenuItem } from '@material-ui/core';
import DatePicker from './date-picker';
import DayAndMonthPicker from './day-and-month-picker';
import TextField from '../text-field/text-field';
import WeekdayToggleButtons from './weekday-toggle-button';
import daysOfWeek from '../../models/days-of-week';

const styles = {
  frequencySelect: {
    marginRight: 10,
  },
  inlineTextfield: {
    marginLeft: 10,
    marginRight: 10,
    width: '50px',
  },
};

const convertBinaryToDays = (number) => {
  const days = [];
  for (let i = 1; i < 8; i++) {
    if ((number & (1 << i)) === 1 << i) {
      // enabled
      days.push(i);
    }
  }
  return days;
};


const Selector = ({
  selector, interval, date, selectors, onChange,
}) => {
  const handleWeekdayToggle = (_, value) => {
    const selectedDays = daysOfWeek.filter(day => value.includes(day.id));
    const selectedInterval = selectedDays.map(d => d.value).reduce((a, b) => a + b, 0);
    onChange({ interval: selectedInterval });
  };

  const handleDayOfMonthChange = (newInterval) => {
    if (newInterval < 1) {
      onChange({ interval: 1 });
    } else if (newInterval > 31) {
      onChange({ interval: 31 });
    } else {
      onChange({ interval: newInterval });
    }
  };


  switch (selector) {
    case selectors.dayOfWeek:
      return (
        <WeekdayToggleButtons
          buttonStyle={{ height: '100%', flex: 1 }}
          buttonGroupStyle={{ width: '100%', paddingTop: 6 }}
          onChange={handleWeekdayToggle}
          value={convertBinaryToDays(interval)}
        />
      );
    case selectors.dayOfMonth:
      return (
        <div style={{ display: 'flex', alignItems: 'baseline' }}>
          am
          <TextField
            style={styles.inlineTextfield}
            type="number"
            inputProps={{ min: 1, max: 31, step: 1 }}
            value={interval}
            onChange={e => handleDayOfMonthChange(e.target.value)}
          />
          des Monats
        </div>
      );
    case selectors.dayAndMonth:
      return <DayAndMonthPicker value={interval} onChange={e => onChange({ interval: e })} />;
    case selectors.date:
      return (
        <div>
          <span style={{ marginRight: 10 }}>am</span>
          <DatePicker
            value={date}
            onChange={d => onChange({ date: d })}
          />
        </div>
      );
    default:
      return null;
  }
};


const ReportFrequencyInput = (props) => {
  const {
    frequencies, selectedInterval, frequency, onChange, ...others
  } = props;

  const handleChangeFrequency = (newFrequency) => {
    const selectedFrequency = frequencies.find(f => f.id === newFrequency);

    onChange({ frequency: newFrequency, interval: selectedFrequency.defaultInterval });
  };

  return (
    <div style={{ display: 'flex' }}>
      <Select style={styles.frequencySelect} value={frequency} onChange={e => handleChangeFrequency(e.target.value)}>
        {frequencies.map(i => <MenuItem key={i.id} value={i.id}>{i.name}</MenuItem>)}
      </Select>
      <Selector
        onChange={onChange}
        selector={selectedInterval && selectedInterval.selector}
        frequencies={frequencies}
        {...others}
      />
    </div>

  );
};

ReportFrequencyInput.propTypes = {
  date: PropTypes.object,
  interval: PropTypes.number.isRequired,
  frequency: PropTypes.number.isRequired,
  selectors: PropTypes.object.isRequired,
  selectedInterval: PropTypes.object.isRequired,
  frequencies: PropTypes.array,
  onChange: PropTypes.func.isRequired,
};

ReportFrequencyInput.defaultProps = {
  date: null,
  frequencies: [],
};

Selector.propTypes = {
  date: PropTypes.object,
  interval: PropTypes.number.isRequired,
  selector: PropTypes.string.isRequired,
  selectors: PropTypes.object.isRequired,
  onChange: PropTypes.func,
};

Selector.defaultProps = {
  date: null,
  onChange: () => {},
};

export default ReportFrequencyInput;
